function SvgDatabase(props) {
  return (
    <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <defs>
        <path d="M0 0h24v19.826H0z" id="database_svg__a" />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(0 2)">
        <mask fill="#fff" id="database_svg__b">
          <use xlinkHref="#database_svg__a" />
        </mask>
        <path
          d="M22.413 4.405c-.536.343-1.35.667-2.354.938-2.146.577-5.008.896-8.06.896-3.051 0-5.913-.319-8.058-.896C2.037 4.829.854 4.12.854 3.495c0-.29.253-.605.732-.91.538-.343 1.352-.666 2.355-.938C6.087 1.07 8.949.751 11.999.751s5.913.318 8.06.896c1.904.514 3.088 1.221 3.088 1.848 0 .29-.254.606-.734.91zm.734 3.369c-.002.29-.255.605-.734.91-.538.343-1.351.666-2.354.937-2.146.578-5.008.896-8.06.896-3.05 0-5.912-.318-8.058-.896C2.038 9.108.855 8.399.854 7.775V4.882l.416.241C3.251 6.274 7.363 6.99 12 6.99c4.637 0 8.749-.715 10.73-1.866l.417-.241v2.892zm0 4.279c-.002.29-.255.604-.734.91-.536.342-1.35.667-2.354.937-2.146.578-5.008.896-8.06.896-3.051 0-5.913-.318-8.058-.896-1.903-.513-3.086-1.22-3.087-1.847V9.16l.416.242C3.252 10.553 7.363 11.27 12 11.27c4.637 0 8.749-.716 10.73-1.868l.417-.242v2.894zm0 4.278c-.002.29-.255.606-.734.91-.536.342-1.35.666-2.354.937-2.148.579-5.01.897-8.06.897-3.049 0-5.91-.318-8.058-.897-1.903-.512-3.086-1.22-3.087-1.847V13.44l.416.241c1.981 1.151 6.093 1.867 10.73 1.867 4.637 0 8.749-.716 10.73-1.867l.417-.241v2.892zm.853.025V3.496C24 1.225 17.818 0 12 0S0 1.225 0 3.495V16.33c.001 2.27 6.183 3.495 12 3.495 5.743 0 11.9-1.206 12-3.441v-.03z"
          fill="currentColor"
          mask="url(#database_svg__b)"
        />
      </g>
    </svg>
  )
}

export default SvgDatabase
